/**
 * {@link IOspAuthModule} backed entirely by {@link OspSecurityWorker} (no SDK AuthModule).
 */

import type { IOspAuthModule } from "@/src/features/auth/compat/sdk-types";

import type { OspSecurityWorker } from "./ospSecurity";

export function createAppAuthModule(
  security: OspSecurityWorker,
): IOspAuthModule {
  return {
    storage: security.storage,
    authenticate: (eoa_address, signature, options) =>
      security.authenticate(eoa_address, signature, options),
    refreshToken: async (check, expTime) => {
      const credentials = await security.refreshCredentials(check, expTime);
      if (!credentials) {
        return null;
      }
      return {
        accessToken: credentials.accessToken,
        refreshToken: credentials.refreshToken,
      };
    },
    getLoginInfo: () => security.getLoginInfo(),
    idToken: () => security.idToken(),
    logout: () => security.logout(),
  };
}
